import { useEffect, useState } from "react";

import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";

import { Link } from "react-router-dom";
import TokenService from "../../../../Services/Token.service";
import { AdminService } from "../../../../Services/Admin.service";
import SearchInput from "../../../../Components/AdministrativeSettings/SearchInput";
import AdminRoleDropdown from "../../../../Components/AdministrativeSettings/AdminRoleDropdown";
import AdminStatusDropdown from "../../../../Components/AdministrativeSettings/AdminStatusDropdown";
import LoadingComponent from "../../../../Components/LoadingComponent";
import AdminTableRow from "../../../../Components/AdministrativeSettings/AdminTableRow";
import NoListDataAvailable from "../../../../Components/NoListDataAvailable";

import Toaster from "../../../../Components/Toaster";
import ToTheUserTableRow from "../../../../Components/AdministrativeSettings/Email-SMS-Management/ToTheUserTableRow";
import TablePagination from "../../../../Components/AdministrativeSettings/TablePagination";
import SampleTypeDropdown from "../../../../Components/AdministrativeSettings/SampleTypeDropdown";
import Loader from "../../../../Components/Loader";
import SingleSelectDropdown from "../../../../Components/SingleSelectDropdown";
import { useMediaQuery } from "react-responsive";

function ToTheUserTable(props) {

    const [loading, setLoading] = useState(true);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalEmailTemplates, setTotalEmailTemplates] = useState(0);
    const [emailTemplateList, setEmailTemplateList] = useState([]);

    const [statuses, setStatuses] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);

    const [from, setFrom] = useState([]);
    const [selectedFrom, setSelectedFrom] = useState();

    const [bcc, setBCC] = useState([]);
    const [selectedBCC, setSelectedBCC] = useState();


    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [searchMessegeTitle, setSearchMessegeTitle] = useState("");
    const [isSearchMessegeTitleInputVisible, setSearchMessegeTitleInputVisible] = useState(false);

    const [searchSubject, setSearchSubject] = useState("");
    const [isSearchSubjectVisible, setSearchSubjectVisible] = useState(false);
 
    const { isClearFilter } = props;
    const {type} =props;
    const { onFilterCountChange } = props;
    useEffect(() => {
        if (isClearFilter) {
            setSelectedStatuses([]);
            setSelectedFrom();
            setSelectedBCC();
            setSearchMessegeTitle("");
            setSearchMessegeTitleInputVisible(false);
            setSearchSubject("");
            setSearchSubjectVisible(false);
            onFilterCountChange(0);
        }
    }, [isClearFilter]);

    // Calculate and update the filter count
    useEffect(() => {
        const count = [
            selectedStatuses.length > 0 ? 1 : 0,
            selectedFrom ? 1 : 0,
            selectedBCC ? 1 : 0,

            searchMessegeTitle ? 1 : 0,
            searchSubject ? 1 : 0,

        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [selectedStatuses,selectedFrom, selectedBCC, searchMessegeTitle, searchSubject]);

    useEffect(() => {

        fetchStatuses();
        fetchFrom();
        fetchBCC();
    }, []);

    useEffect(() => {
        fetchAdminList();
    }, [pagination, selectedStatuses ,selectedFrom, selectedBCC, searchMessegeTitle, searchSubject]);

    const userId = TokenService.getUserId();
    function fetchAdminList() {


        const filters = {
            title: searchMessegeTitle,
            subject: searchSubject,
            status: selectedStatuses,
            from: selectedFrom,
            bcc: selectedBCC,
        };

        const typeMap = { admin: 1, requestor: 2, donor: 3 };
        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            type_id: typeMap[type],
            type: "list",  //list | common  --- When common no need to pass type id
            filters: filters,
        };

        AdminService.getEmailTempletList(params)
            .then((response) => { 
                setLoading(true);
                setEmailTemplateList(response.data.list);
                setTotalEmailTemplates(response.data.total);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error("Failed to fetch emailTemplate list", error);
                setLoading(false);
            });
    }

    async function fetchFrom () {
        try {
            console.log("Fetching email options...");
            const options = await AdminService.getEmailTempletOptions();
            
            if(options.success){ 

                const formattedOptions = options.emails.map((email) => ({
                    id: `${email.email}`, 
                    // (${email.email})
                    label: email.name,  
                }));


                setFrom(formattedOptions);
            }
          } catch (err) {
            console.error("Error fetching email options:", err);
       
          }
    }
    
    async function fetchBCC() {
        try {
            console.log("Fetching email options...");
            const options = await AdminService.getEmailTempletOptions();
            
            if(options.success){
 
                const formattedOptions = options.emails.map((email) => ({
                    id: `${email.email}`, 
                    // (${email.email})
                    label: email.name,  
                }));


                setBCC(formattedOptions);
            }
          } catch (err) {
            console.error("Error fetching email options:", err);
       
          }
    }


    function fetchStatuses() {
        AdminService.getAdminListStatusTypes()
            .then((statusTypes) => {
                setStatuses(statusTypes);

            })
            .catch((error) => {
                console.error("Failed to fetch status types", error);
            });
    }
    const handleFromChange = (sample) => {
        
        setSelectedFrom(sample); // Single value
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleBCCChange = (sample) => {
        setSelectedBCC(sample); // Single value
        setPagination({ ...pagination, page: 1, offset: 0 });
        
    };


    const handleStatusChange = (status) => {
        if (selectedStatuses.includes(status)) {
            setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
        } else {


            setSelectedStatuses([...selectedStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleChangeStatus = async (emailTemplate, status) => {
        setLoading(true);
        const newStatus = emailTemplate.active ? 0 : 1; // Determine the new status
        try {
            const response = await AdminService.changeEmailTemplateEmailStatus(emailTemplate.id, newStatus); // Pass the user ID and new status

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                fetchAdminList();
                setLoading(false);

            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);

            }
        } catch (error) {
            console.error("Failed to change user status:", error);
            setLoading(false);

        }
    };

    const handleDeleteUser = async (userId) => {
        try {

            const response = await AdminService.deleteEmailTemplate(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Email Template deleted successfully:", response);
                fetchAdminList();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to delete email template:", error);
        }
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {

        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalEmailTemplates);
            setPagination({ limit: totalEmailTemplates, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = emailTemplateList.length;  //ex 10 
    const totalPages = Math.ceil(totalEmailTemplates / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };

    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <div>
            <Loader loading={loading} />
            {isMobile ? (
           <div className="admin-card-list mt-3">
           {emailTemplateList.length > 0 ? (
             <div  className="row"> {
            emailTemplateList.map((emailTemplate, index) => (
                <div className="col-sm-12 col-md-6 mb-3" key={index}>
                            <ToTheUserTableRow
                                key={index}
                                emailTemplate={emailTemplate}
                                handleChangeStatus={handleChangeStatus}
                                handleDeleteUser={handleDeleteUser}
                                type={type}
                            />
                            </div>
                        ))}</div>) : (<NoListDataAvailable type="emailTemplate" />)}
         </div>
         ):(<>
         
            <div className="el-table-container el-board-table table-x-scroll">
                <Table hover >
                    <thead>
                        <tr>
                            <th>
                                <SearchInput
                                    label="Message Title"
                                    value={searchMessegeTitle}
                                    setValue={setSearchMessegeTitle}
                                    isVisible={isSearchMessegeTitleInputVisible}
                                    setVisible={setSearchMessegeTitleInputVisible}
                                />
                            </th>
                            <th>
                                <SearchInput
                                    label="Subject"
                                    value={searchSubject}
                                    setValue={setSearchSubject}
                                    isVisible={isSearchSubjectVisible}
                                    setVisible={setSearchSubjectVisible}
                                />
                            </th>
                            <th>

                                <SingleSelectDropdown
                                    samples={from}
                                    selectedSamples={selectedFrom}
                                    handleSampleChange={handleFromChange}
                             
                                    type="from" />
                            </th>
                            {/* <th>

                                <SampleTypeDropdown
                                    samples={bcc}
                                    selectedSamples={selectedBCC}
                                    handleSampleChange={handleBCCChange}
                                    setSelectedSamples={setSelectedBCC} 
                                    type="bcc"/>
                            </th> */}
                             <th>
                                <SingleSelectDropdown
                                    samples={bcc}
                                    selectedSamples={selectedBCC}
                                    handleSampleChange={handleBCCChange} 
                                    type="bcc" /> 
                            </th>
                            <th>
                                <AdminStatusDropdown
                                    statuses={statuses}
                                    selectedStatuses={selectedStatuses}
                                    handleStatusChange={handleStatusChange}
                                    setSelectedStatuses={setSelectedStatuses}
                                    label="Status"
                                />
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {emailTemplateList.length > 0 ? (emailTemplateList.map((emailTemplate, index) => (
                            <ToTheUserTableRow
                                key={index}
                                emailTemplate={emailTemplate}
                                handleChangeStatus={handleChangeStatus}
                                handleDeleteUser={handleDeleteUser}
                                type={type}
                            />
                        ))) : (<NoListDataAvailable type="emailTemplate" />)}
                    </tbody>
                </Table>
            </div>
            </>)}
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                totalEmailTemplates={totalEmailTemplates}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
    );
}
export default ToTheUserTable;
